/* eslint-disable */
const i18n = {
  pageTitle: 'Infiniti Lease & Finance Payment Calculator | INFINITI USA',
  brandTitle: 'INFINITI',
  metaDescriptionStart: 'Calculate your monthly payments on the lease or purchase of a INFINITI',
  metaVehicle: 'vehicle',
  metaDescriptionEnd: ', including current offers. INFINITIUSA Official Site.',
  seoContent: {
    description: 'INFINITI USA Official Site | Calculate lease and finance payments on all INFINITI cars, crossovers, and SUVs',
    canonical: 'https://www.infinitiusa.com/lease-finance-payment-calculator/',
    twitter: {
      card: 'summary_large_image',
      site: '@InfinitiUSA',
      title: 'INFINITI Lease & Finance Payment Calculator',
      description: 'Calculate your monthly payments on the lease or purchase of a new INFINITI vehicle, including current offers.',
      imageSrc: '',
      creator: '@InfinitiUSA'
    },
    facebook: {
      title: 'INFINITI Lease & Finance Payment Calculator',
      description: 'Calculate your monthly payments on the lease or purchase of a new INFINITI vehicle, including current offers.',
      type: 'website',
      siteName: 'INFINITI USA',
      url: 'https://www.infinitiusa.com/lease-finance-payment-calculator/',
      image: 'https://infinitiusa.com/dam/infiniti/vehicles/crossover/qx30/2017/sav/2017-infiniti-qx30-medium.jpg',
      imageWidth: '1200',
      imageHeight: '630'
    }
  },
  paymentTypes: {
    lease: 'Lease',
    finance: 'Finance'
  },
  optionTypes: {
    offer: 'Offer',
    incentive: 'Incentive'
  },
  titlePanel: {
    title: 'Payment Calculator',
    description: 'Use this tool to estimate monthly payments on a lease or finance of your INFINITI vehicle.'

  },
  trimSelectPanel: {
    locationAccordion: 'My Location & Credit Rating',
    modelSelectDefault: 'Select a Vehicle',
    trimSelectDefault: 'Select a Model',
    editLink: 'EDIT',
    doneLink: 'DONE',
    popularEquippedLabel: 'Base Price'
  },
  trimFilter: {
    allVehicles: 'ALL VEHICLES'
  },
  moreOffersToggle: {
    moreOffers: 'SEE MORE OFFERS',
    lessOffers: 'SEE LESS OFFERS',
  },
  personalizePanel: {
    personalizeTitle: 'PERSONALIZE MY PAYMENT',
    locationText: 'My Location: ',
    locationLabelDefault: 'Cannot retrieve location',
    downPayment: 'Down Payment',
    downPaymentDisclaimer: 'A payment in cash and/or rebate upon the signing of a loan/lease, which typically reduces the amount financed on a loan or lease and/or pays for other amounts due upon the signing of a lease. The down payment is only one part of the total due at lease signing. See the Total Due at Lease Signing section for a complete list of itemized costs.',
    tradeIn: 'Net Trade-in Value',
    tradeInDisclaimer: 'The net value that your INFINITI Retailer will credit your current vehicle toward the purchase or lease of another vehicle.',
    intelliPriceText: 'Estimate Trade-in Value',
    resetButtonText: 'RESET',
    maxMonthlyBudget: 'My Max Monthly Budget',
    accessoriesDisclaimer: "Accessories are defined as any item installed at an INFINITI Retailer and not by the factory. For purposes of a lease, or APR payment, this amount will be added to the total sales price of the vehicle, but not to the Lease residual value of the car at the end of the financing term. For specific details please see your INFINITI Retailer. Some accessories may require installation, which is not included in the Manufacturer's Suggested Retail Price (MSRP). Retailer sets actual price.",
    personalizedAmount: 'Total Personalized Amount:',
    creditRating: 'Credit Rating: ',
    estimateCredit: 'Estimate credit score',
    creditSelect: [
      {
        text: 'Excellent (740+)',
        value: '0'
      },
      {
        text: 'Great (700-739)',
        value: '1'
      },
      {
        text: 'Good (660-699)',
        value: '2'
      },
      {
        text: 'Fair (620-659)',
        value: '3'
      },
      {
        text: 'Poor (600-619)',
        value: '4'
      }
    ]
  },
  filterPanel: {
    select: 'Select',
    noFilter: 'No Filter',
    lease: 'Lease',
    finance: 'Finance'
  },
  offerPanel: {
    topPanel: {
      offerText: 'OFFER',
      detailsText: 'SPECIAL PRICING APPLIED',
      monthText: 'MONTH',
      termText: 'Term',
      termDisclaimer: 'The duration of your loan or lease, usually measured in months (e.g., 48 months).',
      termSelectorLabel: 'months',
      monthlyPayment: 'MONTHLY PAYMENT',
      offerDetails: 'OFFER DETAILS',
      mileage: 'Mileage',
      mileageDisclaimer: 'A lease agreement sets annual mileage limits. Mileage beyond these limits will incur an added charge.',
      apr: 'APR',
      aprDisclaimer: 'The cost of your credit as a yearly rate. This field defaults to an assumed number. The actual rate you qualify for may vary based on your credit.',
      cashBackTitle: 'Cashback',
      addOffer: 'ADD OFFER',
      removeOffer: 'REMOVE OFFER',
      lease: 'LEASE',
      finance: 'FINANCE',
      offerWindow1: 'PER MONTH FOR',
      mileageOptions: {
        10000: 'X',
        12000: 'L',
        15000: 'S'
      },
      mileageLabels: {
        X: "10,000 miles/yr",
        L: "12,000 miles/yr",
        S: "15,000 miles/yr"
      }
    },
    detailsModal: {
      offerText: 'OFFER',
      offerDetails: 'PaymentOption details:',
      initialPayment: 'INITIAL PAYMENT',
      month: '/month',
      btnRemove: 'Would you like to remove ',
      btnAdd: 'Would you like to add ',
      btnContent2: ' and apply the changes?',
      includeBtn: 'Include Offer',
      removeBtn: 'Remove Offer',
      close: 'Close'
    },
    summaryPanel: {
      paymentSummaryText: 'PAYMENT SUMMARY',
      estimatedAmount: 'Estimated Amount Financed',
      aquisitionFee: 'Acquisition Fee',
      estimatedAmountText: 'Personalized Amount',
      adjustedCost: 'Adjusted Capitalized Cost',
      signingTotalText: 'Total Due at Signing',
      monthlyPaymentText: 'Monthly Payment',
      retailerButton: 'LOCATE A RETAILER',
      quoteButton: 'SEARCH INVENTORY',
      retailerButtonMKS: 'LOCATE_A_DEALER',
      quoteButtonMKS: "SEARCH_INVENTORY",
      leadFormButtonMKS: 'REQUEST_INTERNET_QUOTE',
      leadFormButton: 'REQUEST INTERNET QUOTE',
      cashback: 'Cashback',
      requiredDownPayment: 'Required Down Payment',
      msrp: 'MSRP',
      totalPrice: 'Total Price',
      leafDefaultDisclaimer: 'Price does not include available federal and state tax credits and incentives which may be available to you.',
      leafLeaseOfferDisclaimer: 'Monthly price shown includes $7,500 in available federal tax credits and incentives. Available state tax credits and incentives not included in price.'
    }
  },
  offerModal: {
    finance: {
      offer: 'Finance Offer',
      incentive: 'Finance Incentive'
    },
    lease: {
      offer: 'Lease Offer',
      incentive: 'Lease Incentive'
    }
  },
  accordionDrawers: [
    {
      title: 'GLOSSARY OF TERMS',
      content: "<h4>Acquisition Fee<\/h4><p>A charge included in most lease transactions that is either paid up front or included in the gross capitalized cost.<\/p><h4>Adjusted Capitalized Cost<\/h4><p>The sum of the MSRP, including destination and handling charges and Federal Gas Tax (if applicable), plus acquisition fees minus the down payment and/or trade in.<\/p><h4>APR<\/h4><p>The cost of your credit as a yearly rate. This field defaults to an assumed number. The actual rate you qualify for may vary based on your credit.<\/p><h4>Capitalized Cost Reduction<\/h4><p>The total of any cash payment, rebates, and/or net trade-in allowance which is applied to a lease in order to reduce the capitalized cost. The capitalized cost reduction is comparable to the \'down payment\' made when purchasing a vehicle.<\/p><h4>Retailer Accessories<\/h4><p>Accessories are defined as any item installed at an INFINITI Retailer and not by the factory. For purposes of a lease, or APR payment, this amount will be added to the total sales price of the vehicle, but not to the Lease residual value of the car at the end of the financing term. For specific details please see your INFINITI Retailer. Some accessories may require installation, which is not included in the Manufacturer's Suggested Retail Price (MSRP). Retailer sets actual price.<\/p><h4>Down Payment<\/h4><p>A payment in cash and/or rebate upon the signing of a loan/lease, which typically reduces the amount financed on a loan or lease and/or pays for other amounts due upon the signing of a lease. The down payment is only one part of the total due at lease signing. See the Total Due at Lease Signing section for a complete list of itemized costs.<\/p><h4>Estimated Amount Financed<\/h4><p>The price that you anticipate you will pay for the INFINITI you've selected. This field will default to the MSRP of the INFINITI that you have selected but may be reduced due to special terms.<\/p><h4>Gross Capitalized Cost<\/h4><p>The Gross Capitalized Cost minus the Capitalized Cost Reduction.<\/p><h4>Mileage<\/h4><p>A lease agreement sets annual mileage limits. Mileage beyond these limits will incur an added charge.<\/p><h4>MSRP<\/h4><p>Price includes destination and handling charges and federal gas tax (if applicable). MSRP excludes tax, title, license and options. Retailers sets actual price. For purposes of a Lease or APR payment the Retailer accessories amount will be added to the total sales price of the vehicle but not to the Lease residual value of the car at the end of the financing term. For specific details please see your INFINITI Retailer. Some accessories may require installation, which is not included in the Manufacturer's Suggested Retail Price (MSRP). Retailer sets actual price.<\/p><h4>Owed on Trade-in<\/h4><p>The amount still owed on a trade-in vehicle.<\/p><h4>Term<\/h4><p>The duration of your loan or lease, usually measured in months (e.g., 48 months).<\/p><h4>Total Due at Lease Signing<\/h4><p>The total amount to be paid prior to or at lease signing or by delivery, if delivery occurs after lease signing.<\/p><h4>Trade-in Value<\/h4><p>The net value that your INFINITI Retailer will credit your current vehicle toward the purchase or lease of another vehicle. This amount may be negative if your current vehicle is worth less than the balance remaining on your current loan or lease.<\/p>",
      accordionOpen: false
    },
    {
      title: 'IMPORTANT ESTIMATOR INFORMATION',
      content: "<p>†<strong>Payment results are estimates and are used for illustrative purposes only.</strong> Many variables will affect your monthly payment. This estimator is not an advertisement, solicitation, credit application or offer for any specific terms of sale price or credit and is not an offer for direct sale, financing or leasing. You should see your local Retailer for actual terms and conditions. See your INFINITI Retailer to help determine your actual monthly payments including title, taxes, license and other fees, based on the exact selling price, lease or financing terms, credit history, trade-in appraisal, down payment and special offers.<\/p><p>The above is how INFINITI Financial Services defines its credit rating ranges. Other creditors may define their credit ratings differently.<\/p><p>References to \'loan\' on this website refer to indirect lending originated by your participating INFINITI Retailer through INFINITI Financial Services.<\/p><p>Trade-in values obtained from Intelliprice are merely estimates. The precise value of your vehicle could differ from the initial estimate. The precise value of your trade-in could be higher or lower depending on the condition of your vehicle, equipment, and local market conditions.<\/p><p>The amounts entered above under \'Personalize My Payment\' impact Amount Financed, Capitalized Cost and final monthly payment. Maximum amounts vary by Lease or Loan product, Credit Score and Term. See Retailer for actual monthly payments.<\/p>",
      accordionOpen: true
    },
    {
      title: 'Get an Internet Quote',
      accordionOpen: true
    }
  ],
  vehicleGrid: {
    startingAt: 'Starting at',
    estimateButton: 'Estimate',
    vehicleMSRPDisclaimer: 'Price is Manufacturer’s Suggested Retail Price (MSRP). MSRP excluding destination charge, tax, title, license and options. Retailer sets actual price.'
  },
  zipCodeModal: {
    zipError: 'Please Enter a Valid Zip Code.',
    zipEnter: 'Enter your Zip Code',
    submitButton: 'SUBMIT'
  },
  linkPaths: {
    blackBookURL: "http://www.intelliprice.com/intellipricedealer/start.htm?dealerid=975200&tool=payment_estimator.estimate_credit_score.link",
    intellipriceURL: "http://www.intelliprice.com/intellipricedealer/start.htm?tool=payment_estimator.estimate_trade_in.link&dealerid=",
    locateARetailer: "/infinitiretailers/?zipCode=",
    requestAQuote: "/buildyourinfiniti/inventory/index",
    zipCodeAmp: "&zipCode=",
    leadFormURL: '#leads-form'
  },
  noIncentives: {
    title: "",
    message: "See your local retailer for your personalized pricing.",
    linkText: "Contact a Retailer now.",
    linkURL: "/buildyourinfiniti/requestQuote"
  },
  paymentOptionError: {
    invalid: "Invalid Payment Option",
    title: "Error",
    financeMessage: "Monthly purchase payment must be less than $10,000",
    leaseMessage: "Monthly lease payment must be less than $10,000",
    reduceLeasePaymentError: 'The est. purchase price minus the net trade-in value and down payment must be greater than ${amt}. Please reduce down payment and/or trade-in amount.',
    financeLowerLimit: 'To finance this vehicle for ${term} months, the minimum financing amount is ${amt}. Please change your selected term, or lower your Trade-in and Down Payment total to ${limit} or less.'
  },
  fetchErrors: {
    dma: 'Sorry for the inconvenience, currently there is no data available to estimate your payment calculation. Please check back soon, or contact your Infiniti Retailer.',
    modelLines: 'Sorry for the inconvenience, currently there is no data available to estimate your payment calculation. Please check back soon, or contact your Infiniti Retailer.',
    trim: 'Sorry for the inconvenience, currently there is no data available to estimate your payment calculation. Please check back soon, or contact your Infiniti Retailer.',
    paymentOptions: 'Sorry for the inconvenience, currently there is no data available to estimate your payment calculation. Please check back soon, or contact your Infiniti Retailer.',
    eimCode: ''
  },
  offerTypeDropdown: {
    label: 'Offer',
    bestAPR: 'Best APR',
    highestCashback: 'Highest Cashback',
    lowestMonthly: 'Lowest Monthly Payment',
    bestAPRCashback: 'Best APR with Cashback'
  },
  leadsFormContent: {
    dealerCard: {
      distanceFrom: 'from',
      selectButton: 'Select',
      milesAbbrev: 'MI'
    },
    dealerList: {
      closestDealers: 'CLOSEST DEALERS TO YOU',
      results: 'Results Found',
      noResults: 'No Results Found',
      resultsError: 'There was an error retrieving the dealerships. Please try again.'
    },
    dealerListZipSearch: {
      selectDealerText: 'SELECT YOUR LOCAL INFINITI RETAILER TO FINISH',
      locateByText: 'LOCATE BY ZIP CODE',
      zipCodeRequired: 'Zip Code is required',
      zipCodeInvalid: 'Invalid Zip code'
    },
    leadsForm: {
      optionalText: '(Optional)',
      privacyPolicy: 'Privacy Policy',
      privacyPolicyURL: '/global/privacy.html',
      unknownError: 'An unknown error has occurred. Please try again.',
      infoText: 'Fill out the form below to get a detailed summary of your INFINITI build by email, and an exclusive price from your preferred Retailer',
      requiredText: '* Required Field',
      firstName: 'First Name *',
      lastName: 'Last Name *',
      address: 'Address *',
      city: 'City *',
      state: 'State *',
      zipCode: 'Zip Code *',
      email: 'Email *',
      phone: 'Phone',
      optIn: 'Yes, I would like to receive exclusive Nissan news and announcements',
      submitButton: 'Request Internet Quote',
      firstNameError: 'First Name is required',
      lastNameError: 'Last Name is required',
      addressError: 'Address is required',
      cityError: 'City is required',
      stateError: 'State is required',
      invalidEmail: 'Invalid email',
      emailError: 'Email is required',
      invalidPhone: 'Invalid phone'
    },
    paginator: {
      prev: 'Prev',
      next: 'Next'
    },
    trimViewPage: {
      thankYouTitle: 'THANK YOU',
      thankYouContent: 'Your dealer will be in contact shortly.',
      zipErrorTitle: 'ZIP CODE ERROR',
      zipErrorContent: 'Your zip code and state don\'t seem to match up. Please take a look and try submitting again.',
      genericErrorTitle: 'UH OH',
      genericErrorContent: 'We\'re sorry, something appears to have gone wrong on our end. Please try again later or contact your local NISSAN dealer.'

    }
  }
};

export default i18n;



/** WEBPACK FOOTER **
 ** ./src/i18n/infiniti/nna/en.js
 **/